import React from "react";
import ReactDOM from "react-dom";
import { getType, isType } from '@utils';

/**
 * reactRender
 * @param Node 
 * @param props 
 * @param getContainer 
 * @returns 
 */
export default function reactRender(Node: any, props: any = {}, getContainer?: Function) {
  let container: any = null;
  if (Node) {
    container = document.createElement('div');
    if (isType(getContainer, 'Function')) {
      const containerCustom = getContainer();
      if (!containerCustom) {
        document.body.appendChild(container);
      } else {
        container = containerCustom;
      }
    } else {
      document.body.appendChild(container);
    }
  }
  function render(newprops: any = {}) {
    if (container) {
      ReactDOM.render(<Node {...props} { ...newprops }/>, container);
    }
  }
  function destroy() {
    if (container) {
      const unmountResult = ReactDOM.unmountComponentAtNode(container);
      if (unmountResult && container.parentNode) {
        container.parentNode.removeChild(container);
      }
    }
  }
  render(props);
  return {
    destroy,
    update: render
  };
}
